export const DASHBOARD = "DASHBOARD";
export const MANAGE = "MANAGE";
